var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        top: "5vh",
        width: "70%",
        modal: false,
        visible: _vm.dialogVisible
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        opened: _vm.dialogOpened
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: { "padding-top": "10px" },
          attrs: { slot: "title" },
          slot: "title"
        },
        [
          _c("span", { staticStyle: { "font-size": "25px" } }, [
            _vm._v("填写表单")
          ]),
          _vm._v(" "),
          _c("LoadFormData", {
            staticClass: "load_form_btn",
            on: { selected: _vm.onLoadFormDataSelected }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("TicketTaskForm", {
        ref: "ref2",
        staticStyle: { margin: "0 10px" },
        attrs: { ticketNo: _vm.ticketNo, workflowId: _vm.workflowId },
        on: {
          cancel: _vm.onCancel,
          afterPost: _vm.afterPost,
          submitAssignToWorkflow: _vm.submitAssignToWorkflow
        },
        model: {
          value: _vm.taskForm,
          callback: function($$v) {
            _vm.taskForm = $$v
          },
          expression: "taskForm"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e02e620", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e02e620","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketTaskFormDialog.vue
// module id = 810
// module chunks = 75